{
  "app": { "title": "85AI 财务及会计系统" },
  "tab": { "aria": "主导航" },
  "nav": { "home": "首页", "capture": "记账", "list": "记录", "reports": "报表", "more": "更多", "back": "返回" },
  "more": { "heading": "更多", "settings": "设置", "evidence": "凭证总览" },
  "settings": { "heading": "设置", "font": "字号", "font_std": "标准", "font_lg": "大", "font_xl": "特大", "font_note": "调大字号更易阅读（仅影响本机）。", "language": "语言" },
  "proof": { "heading": "凭证", "camera": "拍照", "file": "上传文件/PDF", "uploading": "上传中…", "hint": "拍照或上传单据 —— 会计和管理层会依赖这些材料。" },
  "evidence": { "heading": "凭证总览", "search": "搜索", "search_hint": "用途/单号/对象", "count": "{{files}} 张凭证 · {{vouchers}} 张凭单", "empty": "没有凭证（试试改筛选）" },
  "auth": {
    "heading": "登录",
    "phone": "电话号码",
    "pin": "密码（PIN）",
    "sign_in": "登录",
    "signing_in": "登录中…",
    "sign_out": "退出",
    "failed": "电话或密码不正确"
  },
  "changepin": {
    "heading": "设置新 PIN",
    "note": "首次登录必须修改 PIN（临时 PIN 不能继续使用）。至少 6 个字符。",
    "current": "现有 PIN（临时）",
    "new": "新 PIN",
    "confirm": "再次输入新 PIN",
    "save": "确认修改",
    "saving": "保存中…",
    "mismatch": "两次输入的新 PIN 不一致"
  },
  "home": {
    "net": "本月结余",
    "todo": "待办",
    "todo_none": "没有待办 🎉",
    "heading": "首页",
    "entity": "公司",
    "expense": "本月支出",
    "income": "本月收入",
    "period": "期间：{{period}}",
    "pending_reimb": "代垫待补回：{{n}} 笔",
    "capture_cta": "拍照记账",
    "income_cta": "记收入",
    "recent": "最近记录",
    "list_cta": "全部记录",
    "report_cta": "月报",
    "export_cta": "导出",
    "periods_cta": "锁账／审计",
    "profit_cta": "分配试算",
    "budget_cta": "预算对照",
    "items_cta": "应收应付",
    "bank_cta": "银行对账",
    "assets_cta": "固定资产"
  },
  "capture": {
    "heading": "拍照记账",
    "open_camera": "打开相机",
    "pick_file": "选照片／PDF",
    "shoot": "拍照",
    "flip": "前后镜头",
    "cancel": "取消",
    "retake": "重拍",
    "uploaded": "已上传 {{kb}} KB（原件存在私密储存）",
    "saved": "✅ 已记录：{{no}}",
    "back_home": "返回首页",
    "working": "处理中…",
    "working_ocr": "OCR 读取中…",
    "failed": "拍照失败，请重试",
    "denied": "无法打开相机（{{msg}}）—— 可用「选照片」",
    "upload_failed": "上传失败：{{msg}}",
    "guide": "把单据对准框内，点一下画面可锁定对焦",
    "detected": "已侦测到单据 —— 保持不动（自动拍摄）",
    "auto": "自动拍摄：开／关",
    "opening": "正在打开相机…",
    "hold": "已发现单据 —— 保持不动",
    "scan_error": "侦测出错：{{msg}}",
    "manual_hint": "拍照＝框内；点 🤖 可自动找单据并自动拍",
    "adjust_hint": "拖动四个角对准单据四边，再点「拉平使用」",
    "apply": "拉平使用"
  },
  "ocr": {
    "heading": "OCR 自动填表",
    "reading": "正在读取收据…（约 3–10 秒）",
    "done": "读取完成（{{ms}} 毫秒、约 {{neurons}} neurons）",
    "failed": "OCR 失败：{{msg}} —— 仍可手动填写后保存",
    "machine_hint": "🤖 带有此标记的栏位是**机器读取**，保存前请核对一次（尤其金额与日期）。",
    "show_raw": "查看 OCR 原文",
    "hide_raw": "收起原文"
  },
  "expense": {
    "amount": "金额（HK$）",
    "date": "日期",
    "category": "类别",
    "purpose": "用途",
    "purpose_hint": "例：打出租车去 JHC 开会",
    "supplier": "供应商／收款人",
    "supplier_hint": "打字会自动提示（新名称可即时建立）",
    "entity": "公司",
    "paid_by": "谁付款",
    "paid_by_simon": "Simon（个人代垫）",
    "paid_by_raymond": "Raymond（个人代垫）",
    "paid_by_company": "公司",
    "payment_method": "付款方式",
    "account": "付款账户",
    "project": "项目",
    "save": "保存凭证"
  },
  "method": {
    "cash": "现金",
    "bank_transfer": "银行转账",
    "fps": "转数快 FPS",
    "cheque": "支票",
    "credit_card": "信用卡",
    "debit_card": "借记卡",
    "ewallet": "电子钱包",
    "auto_debit": "自动转账",
    "none": "不适用"
  },
  "income": {
    "heading": "记收入",
    "category": "收入类别",
    "account": "收款账户",
    "entity": "公司",
    "customer": "客户／来源名称",
    "customer_hint": "例：JHC／Roadshow 名称／B2B 客户",
    "doc_no": "发票／单据号",
    "attach": "附上发票／入账凭证",
    "attached": "已附上 1 个文件",
    "save": "保存收入"
  },
  "items": {
    "heading": "应收／应付（AR/AP）",
    "kind": "类型",
    "kind_ar": "应收（客户欠我们）",
    "kind_ap": "应付（我们欠供应商）",
    "party": "客户／供应商",
    "issue_date": "开单日",
    "due_date": "到期日",
    "amount": "金额（HK$）",
    "income_code": "收入科目",
    "expense_code": "费用科目",
    "create_ar": "开应收单（出 JV 凭证）",
    "create_ap": "开应付单（出 JV 凭证）",
    "note": "开单会即时出一张凭证（AR：Dr 应收/Cr 收入；AP：Dr 费用/Cr 应付）→ 账目与报表即时正确；之后收款／付款再出一张凭证结算。",
    "created": "✅ 已开单，凭证：{{no}}",
    "settled": "✅ 已结算，凭证：{{no}}（未结余额 {{balance}}）",
    "settle_amount_needed": "请输入本次收款／付款金额",
    "account_needed": "请选择收款／付款账户",
    "open_list": "未结清项目",
    "settle_account": "收款／付款账户",
    "due": "到期 {{date}}",
    "settle_amount": "本次金额",
    "receive": "收款",
    "pay": "付款",
    "aging": "账龄分析（按到期日）",
    "current": "未到期",
    "balance": "未结余额",
    "total": "合计"
  },
  "budget": {
    "heading": "预算 vs 实际",
    "expense_budget": "支出预算",
    "expense_actual": "支出实际",
    "income_budget": "收入预算",
    "income_actual": "收入实际",
    "budget": "预算（HK$）",
    "actual": "实际",
    "variance": "差异",
    "save": "保存预算",
    "saved": "✅ 已更新 {{n}} 行预算（已留审计）",
    "note": "预算是规划数据（可改，每次改动留审计）；实际数字一律由分录计算，与月报一致。",
    "unbudgeted": "无预算但有实际",
    "bad_amount": "金额格式不对：{{v}}（最多 2 位小数）",
    "no_changes": "没有改动任何行"
  },
  "list": {
    "heading": "交易记录",
    "back_home": "返回首页",
    "month": "月份",
    "kind": "类型",
    "all": "全部",
    "kind_payment": "支出",
    "kind_receipt": "收入",
    "search": "搜索",
    "search_hint": "用途／单号／供应商",
    "loading": "载入中…",
    "count": "共 {{n}} 笔",
    "empty": "暂时没有记录",
    "net": "净额 {{amount}}",
    "pending_reimb": "待补回"
  },
  "detail": {
    "back": "返回列表",
    "amount": "金额",
    "status": "状态",
    "status_confirmed": "已确认",
    "status_draft": "草稿",
    "status_locked": "已锁账",
    "status_voided": "已冲销",
    "lines": "分录（借／贷）",
    "gl": "科目",
    "dr": "借 Dr",
    "cr": "贷 Cr",
    "balanced": "Σ借 = Σ贷（由数据库强制，不平写不入）",
    "attachments": "附件（{{n}}）",
    "no_attachment": "没有附件",
    "ocr_meta": "模型：{{model}}｜信心：{{confidence}}",
    "raw_note": "OCR 原文（逐行文字）与完整 JSON 存放在数据库 `ocr_extractions`（可审计）。",
    "void_heading": "红字冲销",
    "void_reason": "冲销原因",
    "void_reason_hint": "例：供应商开错金额／重复入账",
    "void_cta": "确认冲销（出红字单）",
    "void_note": "冲销**不会删除**原单：原单标「已冲销」，另出一张反向分录的冲销单（两边都保留，可审计）。",
    "void_already": "该凭证已冲销（不可再冲；要更正请开新单）",
    "void_done": "已冲销，冲销单：{{no}}",
    "open_reversal": "打开冲销单",
    "voided_by": "已被冲销（冲销单）",
    "reversal_of": "冲销单（原单）"
  },
  "periods": {
    "heading": "会计期间／月结锁账",
    "status": "状态",
    "locked": "已锁账",
    "open": "开放",
    "locked_at": "锁账时间",
    "lock": "锁账",
    "unlock": "解锁",
    "empty": "暂时没有期间（入第一张单会自动开）",
    "note": "锁账 = 该月不准新增／冲销（只可下月出调整分录）—— 会计师月结用。",
    "audit_heading": "审计链验证",
    "audit_cta": "验证审计链",
    "audit_ok": "✅ 审计链完整（{{n}} 笔）",
    "audit_bad": "❌ 审计链断了：{{at}}（{{reason}}）",
    "audit_note": "每笔记录的 hash 都包含前一笔 hash → 改任何一笔，之后全部验证不过（可检测、可举证）。"
  },
  "profit": {
    "heading": "净利分配试算",
    "all_entities": "合并（两间公司）",
    "ai85_pct": "85 AI 占几 %",
    "parties": "85% 各 party（名:%）",
    "parties_hint": "例：Simon:60,Raymond:25（留空＝用设定／占位）",
    "readonly_note": "本页**只做试算，不会过账**（政策未拍板 —— 见 decisions/006）。可即场改比例与名单。",
    "net": "净利",
    "by_entity": "逐间公司",
    "allocation": "分配试算",
    "no_allocation": "净利 ≤ 0 → 不分配",
    "party": "party",
    "total": "合计",
    "posting_disabled": "⏳ 过账（出分录）要等产品负责人拍板：85% 各 party／每间独立或合并／15% 实体转移或账面分配。"
  },
  "report": {
    "heading": "月报",
    "net": "净额",
    "locked": "⚠️ 该月已锁账（不准新增／修改；只可下月出调整分录）",
    "by_category_expense": "支出（按类别）",
    "by_category_income": "收入（按类别）",
    "by_paid_by": "按谁付款",
    "by_method": "按付款方式",
    "by_project": "按项目",
    "by_month": "按月（未选月份）",
    "reimb": "代垫待补回",
    "reimb_none": "没有代垫待补回 ✅",
    "reimb_pending": "待补回 {{amount}}（{{n}} 笔）",
    "reimb_settled": "已补回 {{amount}}"
  },
  "export": {
    "heading": "导出",
    "mode": "范围",
    "mode_month": "按月",
    "mode_range": "按日期范围",
    "from": "由",
    "to": "至",
    "xlsx_cta": "⬇️ 下载 Excel",
    "pack_cta": "🗂️ 下载凭证包 ZIP",
    "xlsx_what": "Excel 四张表：交易明细／月结小计／科目汇总／代垫待补回",
    "pack_what": "凭证包：Excel ＋ 单据影像（文件名＝凭证号）＋ manifest.csv（含 sha256）",
    "note": "两个文件都经登录验证下载（不会公开）。交给会计师可直接审计。"
  },
  "bank": {
    "heading": "银行对账",
    "entity": "公司",
    "account": "银行／现金户头",
    "sync_meta": "户头清单跟公司主档（`meta.accounts`）；要加户头请先在主档加。",
    "status": "状态",
    "status_all": "全部",
    "status_unmatched": "未配对",
    "status_matched": "已配对",
    "status_ignored": "已忽略",
    "import_heading": "汇入月结单（CSV／TSV）",
    "import_hint": "在银行网站／App 导出 CSV（或 Excel 另存 CSV）→ 打开复制 → 贴到下面。要有标题列（日期＋金额 或 存入／支出）。",
    "import_cta": "汇入并去重",
    "csv_needed": "请先贴上 CSV 内容",
    "imported": "✅ 已汇入 {{imported}} 行，跳过重复 {{skipped}} 行",
    "import_errors": "⚠️ 有 {{n}} 行解析不到（不会静默丢行，见下面）",
    "line_count": "共 {{n}} 行",
    "txn_date": "交易日期",
    "description": "摘要",
    "amount": "金额",
    "direction_in": "存入",
    "direction_out": "支出",
    "suggestions": "配对建议",
    "no_suggestion": "没有自动建议（可先去记账，或用「忽略」）",
    "match": "配对",
    "matched": "✅ 已配对：{{no}}",
    "ignore": "忽略",
    "ignore_reason": "忽略原因",
    "ignore_reason_hint": "例：银行手续费未入账",
    "ignore_cta": "确认忽略",
    "ignored": "已忽略：{{reason}}",
    "reason_needed": "请填忽略原因（≥3 字）",
    "all_done": "这一行已经处理过",
    "report_heading": "对账报告",
    "statement_closing": "月结单期末余额",
    "statement_source": "来源：{{src}}",
    "book_balance": "账簿余额（该户头）",
    "difference": "差额（月结单 − 账簿）",
    "unmatched_statement": "未配对月结单行（{{n}}）",
    "unmatched_book": "未配对账簿行（{{n}}）",
    "net": "净额",
    "empty": "暂无资料",
    "explain": "差额 ＝ 两边未配对项目的净额（＝要解释的：未入账／未过数／手续费…）。对账不会改账。",
    "voucher": "凭证"
  },
  "dist": {
    "heading": "净利分配过账（P2-2；政策已拍板）",
    "entity": "公司",
    "period": "期间（要已锁账）",
    "coleadery_pct": "CoLeadery %（10–20）",
    "marketing_pct": "市场推广特别账 %（40–50）",
    "note": "政策（已拍板）：医疗基金 15%／CoLeadery 20%／CoLinkery 10%／市场推广特别账 40%（合计 85%）＋ 85 AI Technology 15%。CoLeadery（10–20%）同市场推广（40–50%）可以逐次改，但两者相加必须 ＝ 60%（五项合计 ＝ 100%）。",
    "preview": "试算（不改账）",
    "income": "收入",
    "expense": "支出",
    "net": "净利",
    "locked": "✅ 已锁账（可以过账）",
    "not_locked": "⚠️ 未锁账（不准过账）",
    "target": "分配对象",
    "code": "科目",
    "amount": "金额",
    "total": "合计",
    "from_retained": "（拨自留存收益）",
    "already": "⚠️ 本期间已经分配过账过（{{amount}}）—— 一期一次；要更正请红字冲销该期凭证。",
    "loss": "⚠️ 净利 ≤ 0（亏损）→ 不分配。",
    "post": "确认过账（出 JV 凭证）",
    "posted": "✅ 已过账 {{no}}：{{amount}}",
    "post_note": "过账 ＝ 一张 JV：Dr 留存收益 ／ Cr 五个对象（逐项一笔，Σ ＝ 净利）。⚠️ 分配是权益拨账 —— 不会出现在损益表。",
    "history": "分配记录",
    "base_net": "分配基础（净利）"
  },
  "assets": {
    "heading": "固定资产（折旧）",
    "entity": "公司",
    "status": "状态",
    "status_active": "使用中",
    "status_disposed": "已处置",
    "status_all": "全部",
    "count": "使用中 {{n}} 项",
    "cost": "成本",
    "accumulated": "累计折旧",
    "book_value": "账面净值",
    "monthly": "每月",
    "this_period": "本期折旧",
    "total": "合计",
    "remaining_months": "剩 {{n}} 期",
    "create_heading": "新增资产",
    "name": "资产名",
    "name_hint": "例：MacBook Pro M4（设计用）",
    "category": "分类",
    "acquired_date": "购入日",
    "salvage": "残值",
    "life_months": "使用年限（月）",
    "create": "新增资产（自动编号 FA-YYYY-MM-####）",
    "created": "✅ 已新增资产",
    "form_note": "直线法：每月折旧 ＝（成本 − 残值）÷ 年限月数；最后一期补足差额（Σ 折旧 ＝ 成本 − 残值）。购入当月开始计提。",
    "dep_heading": "每月折旧（一个期间一张凭证）",
    "period": "期间",
    "preview": "试算（不改账）",
    "post": "确认过账（出 JV 凭证）",
    "posted": "✅ 已过账 {{no}}：{{amount}}（{{n}} 项资产）",
    "already_posted": "⚠️ 本期间已经过账过（{{no}}）—— 一个期间只能过账一次；要更正请红字冲销该期凭证。",
    "nothing": "本期间没有需要折旧的资产（未购入／已折旧完／已处置）→ 不会出空凭证。",
    "post_note": "过账 ＝ 出一张 JV：Dr 5210 折旧费用／Cr 1390 累计折旧（逐项资产一对 line，可追溯）。折旧是费用（影响 85:15 分配），但不涉及现金。",
    "list_heading": "资产清单",
    "asset_no": "资产编号",
    "proceeds": "处置价",
    "dispose": "处置（出售／报废）",
    "disposed": "✅ 已处置 {{no}}：账面净值 {{book}}、收益 {{gain}}",
    "runs": "折旧过账记录",
    "run_detail": "{{n}} 项资产"
  }
}
